var _marker, _marker2, _marker3, _marker4, _marker5, _marker6, _rect, _rect2, _text, _text2, _line, _rect3, _text3, _rect4, _text4, _line2, _circle, _text5, _circle2, _text6, _circle3, _text7, _line3, _rect5, _text8, _line4, _circle4, _text9, _circle5, _text0, _circle6, _text1, _line5, _line6, _line7, _line8, _rect6, _text10, _text11, _rect7, _text12, _text13, _rect8, _text14, _text15, _rect9, _text16, _text17, _line9, _line0, _line1, _line10, _rect0, _text18, _line11, _circle7, _text19, _circle8, _text20, _circle9, _text21, _line12, _rect1, _text22, _line13, _circle0, _text23, _circle1, _text24, _circle10, _text25, _circle11, _text26, _rect10, _text27, _rect11, _text28, _line14, _circle12, _text29, _circle13, _text30, _line15, _rect12, _text31, _line16, _circle14, _text32, _circle15, _text33, _line17, _rect13, _text34, _line18, _circle16, _text35, _circle17, _text36, _line19, _rect14, _text37, _line20, _circle18, _text38, _circle19, _text39, _rect15, _text40, _rect16, _text41, _line21, _circle20, _text42, _circle21, _text43, _rect17, _text44, _line22, _circle22, _text45, _circle23, _text46, _rect18, _text47, _line23, _circle24, _text48, _circle25, _text49, _rect19, _text50, _line24, _circle26, _text51, _circle27, _text52, _line25, _text53, _line26, _text54, _line27, _text55, _line28, _text56, _line29, _text57, _line30, _text58;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAgentPipeline(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 960,
    height: 650,
    viewBox: "0 0 960 650",
    xmlns: "http://www.w3.org/2000/svg",
    fontFamily: "Inter, system-ui, sans-serif",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _marker || (_marker = /*#__PURE__*/React.createElement("marker", {
    id: "amc",
    markerWidth: 8,
    markerHeight: 8,
    refX: 8,
    refY: 3,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,6 L8,3 z",
    fill: "#06B6D4"
  }))), _marker2 || (_marker2 = /*#__PURE__*/React.createElement("marker", {
    id: "amg",
    markerWidth: 8,
    markerHeight: 8,
    refX: 8,
    refY: 3,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,6 L8,3 z",
    fill: "#22c55e"
  }))), _marker3 || (_marker3 = /*#__PURE__*/React.createElement("marker", {
    id: "amv",
    markerWidth: 8,
    markerHeight: 8,
    refX: 8,
    refY: 3,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,6 L8,3 z",
    fill: "#a78bfa"
  }))), _marker4 || (_marker4 = /*#__PURE__*/React.createElement("marker", {
    id: "amo",
    markerWidth: 8,
    markerHeight: 8,
    refX: 8,
    refY: 3,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,6 L8,3 z",
    fill: "#f59e0b"
  }))), _marker5 || (_marker5 = /*#__PURE__*/React.createElement("marker", {
    id: "amp",
    markerWidth: 8,
    markerHeight: 8,
    refX: 8,
    refY: 3,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,6 L8,3 z",
    fill: "#f472b6"
  }))), _marker6 || (_marker6 = /*#__PURE__*/React.createElement("marker", {
    id: "ams",
    markerWidth: 8,
    markerHeight: 8,
    refX: 8,
    refY: 3,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,6 L8,3 z",
    fill: "#64748b"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "abg",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#0c1628"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#060c14"
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 960,
    height: 650,
    fill: "url(#abg)",
    rx: 12
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 960,
    height: 650,
    fill: "none",
    rx: 12,
    stroke: "rgba(255,255,255,0.06)",
    strokeWidth: 1
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 480,
    y: 34,
    textAnchor: "middle",
    fill: "#e2e8f0",
    fontSize: 15,
    fontWeight: 700,
    letterSpacing: -0.3
  }, "Portfolio Agent \u2014 Multi-Step Planning &amp; Scheduling Pipeline")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 480,
    y: 51,
    textAnchor: "middle",
    fill: "#7dd3fc",
    fontSize: 9.5
  }, "LangGraph \xB7 FastAPI \xB7 Google Calendar &amp; Gmail APIs \xB7 Cloud Run")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 63,
    x2: 920,
    y2: 63,
    stroke: "rgba(255,255,255,0.07)",
    strokeWidth: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 70,
    width: 932,
    height: 220,
    rx: 8,
    fill: "rgba(6,182,212,0.02)",
    stroke: "#06B6D4",
    strokeWidth: 1,
    strokeDasharray: "6,4"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 28,
    y: 85,
    fill: "#0e7490",
    fontSize: 8.5,
    fontStyle: "italic",
    fontWeight: 600
  }, "PLAN &amp; ROUTE \u2014 every visitor message, in real time")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 100,
    width: 140,
    height: 190,
    rx: 6,
    fill: "#0a1628",
    stroke: "#f472b6",
    strokeWidth: 1.5
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 96,
    y: 118,
    textAnchor: "middle",
    fill: "#f472b6",
    fontSize: 10,
    fontWeight: 700
  }, "Incoming Message")), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 38,
    y1: 126,
    x2: 154,
    y2: 126,
    stroke: "rgba(244,114,182,0.12)",
    strokeWidth: 1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 141,
    r: 2.5,
    fill: "#f472b6",
    opacity: 0.7
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 47,
    y: 145,
    fill: "#cbd5e1",
    fontSize: 8
  }, "Moderation check (OpenAI)")), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 158,
    r: 2.5,
    fill: "#f472b6",
    opacity: 0.7
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 47,
    y: 162,
    fill: "#cbd5e1",
    fontSize: 8
  }, "lang / name / email / tz")), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 175,
    r: 2.5,
    fill: "#f472b6",
    opacity: 0.7
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 47,
    y: 179,
    fill: "#cbd5e1",
    fontSize: 8
  }, "from the form, not free text")), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 166,
    y1: 195,
    x2: 180,
    y2: 195,
    stroke: "#f472b6",
    strokeWidth: 1.5,
    markerEnd: "url(#amp)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 100,
    width: 150,
    height: 190,
    rx: 6,
    fill: "#0a1628",
    stroke: "#06B6D4",
    strokeWidth: 1.5
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 255,
    y: 118,
    textAnchor: "middle",
    fill: "#06B6D4",
    fontSize: 10,
    fontWeight: 700
  }, "plan \u2014 router")), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 192,
    y1: 126,
    x2: 318,
    y2: 126,
    stroke: "rgba(6,182,212,0.12)",
    strokeWidth: 1
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 192,
    cy: 141,
    r: 2.5,
    fill: "#06B6D4",
    opacity: 0.7
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 201,
    y: 145,
    fill: "#cbd5e1",
    fontSize: 8
  }, "chat_json classifies message")), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 192,
    cy: 158,
    r: 2.5,
    fill: "#06B6D4",
    opacity: 0.7
  })), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 201,
    y: 162,
    fill: "#cbd5e1",
    fontSize: 8
  }, "sees full conversation window")), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 192,
    cy: 175,
    r: 2.5,
    fill: "#06B6D4",
    opacity: 0.7
  })), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 201,
    y: 179,
    fill: "#cbd5e1",
    fontSize: 8
  }, "clears stale scheduling state")), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 330,
    y1: 120,
    x2: 344,
    y2: 120,
    stroke: "#64748b",
    strokeWidth: 1.5,
    markerEnd: "url(#ams)"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 330,
    y1: 170,
    x2: 344,
    y2: 170,
    stroke: "#f472b6",
    strokeWidth: 1.5,
    markerEnd: "url(#amp)"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 330,
    y1: 220,
    x2: 344,
    y2: 220,
    stroke: "#22c55e",
    strokeWidth: 1.5,
    markerEnd: "url(#amg)"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 330,
    y1: 270,
    x2: 344,
    y2: 270,
    stroke: "#f59e0b",
    strokeWidth: 1.5,
    markerEnd: "url(#amo)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 344,
    y: 100,
    width: 190,
    height: 40,
    rx: 5,
    fill: "#0a1628",
    stroke: "#64748b",
    strokeWidth: 1.5
  })), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 439,
    y: 115,
    textAnchor: "middle",
    fill: "#94a3b8",
    fontSize: 9,
    fontWeight: 700
  }, "casual_reply_step")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 439,
    y: 128,
    textAnchor: "middle",
    fill: "#64748b",
    fontSize: 7.5
  }, "small talk \u2014 bypasses RAG")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 344,
    y: 150,
    width: 190,
    height: 40,
    rx: 5,
    fill: "#0a1628",
    stroke: "#f472b6",
    strokeWidth: 1.5
  })), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 439,
    y: 165,
    textAnchor: "middle",
    fill: "#f472b6",
    fontSize: 9,
    fontWeight: 700
  }, "contact_request_step")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 439,
    y: 178,
    textAnchor: "middle",
    fill: "#9d5170",
    fontSize: 7.5
  }, "fixed template: email + offer to schedule")), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 344,
    y: 200,
    width: 190,
    height: 40,
    rx: 5,
    fill: "#0a1628",
    stroke: "#22c55e",
    strokeWidth: 1.5
  })), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 439,
    y: 215,
    textAnchor: "middle",
    fill: "#22c55e",
    fontSize: 9,
    fontWeight: 700
  }, "retrieve_knowledge")), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 439,
    y: 228,
    textAnchor: "middle",
    fill: "#166534",
    fontSize: 7.5
  }, "\u2192 RAG API /ask (grounded Q&amp;A)")), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 344,
    y: 250,
    width: 190,
    height: 40,
    rx: 5,
    fill: "#0a1628",
    stroke: "#f59e0b",
    strokeWidth: 1.5
  })), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 439,
    y: 265,
    textAnchor: "middle",
    fill: "#f59e0b",
    fontSize: 9,
    fontWeight: 700
  }, "schedule_step")), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 439,
    y: 278,
    textAnchor: "middle",
    fill: "#92600a",
    fontSize: 7.5
  }, "\u2192 Calendar freebusy.query")), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 534,
    y1: 120,
    x2: 548,
    y2: 120,
    stroke: "#64748b",
    strokeWidth: 1.5,
    markerEnd: "url(#ams)"
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    x1: 534,
    y1: 170,
    x2: 548,
    y2: 170,
    stroke: "#f472b6",
    strokeWidth: 1.5,
    markerEnd: "url(#amp)"
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    x1: 534,
    y1: 220,
    x2: 548,
    y2: 220,
    stroke: "#22c55e",
    strokeWidth: 1.5,
    markerEnd: "url(#amg)"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 534,
    y1: 270,
    x2: 548,
    y2: 270,
    stroke: "#f59e0b",
    strokeWidth: 1.5,
    markerEnd: "url(#amo)"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 548,
    y: 100,
    width: 150,
    height: 190,
    rx: 6,
    fill: "#0a1628",
    stroke: "#06B6D4",
    strokeWidth: 1.5
  })), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 623,
    y: 118,
    textAnchor: "middle",
    fill: "#06B6D4",
    fontSize: 10,
    fontWeight: 700
  }, "compose_response")), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 560,
    y1: 126,
    x2: 686,
    y2: 126,
    stroke: "rgba(6,182,212,0.12)",
    strokeWidth: 1
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 560,
    cy: 141,
    r: 2.5,
    fill: "#06B6D4",
    opacity: 0.7
  })), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 569,
    y: 145,
    fill: "#cbd5e1",
    fontSize: 8
  }, "bilingual reply (EN/ES)")), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 560,
    cy: 158,
    r: 2.5,
    fill: "#06B6D4",
    opacity: 0.7
  })), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 569,
    y: 162,
    fill: "#cbd5e1",
    fontSize: 8
  }, "meeting proposal / slot list")), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 560,
    cy: 175,
    r: 2.5,
    fill: "#06B6D4",
    opacity: 0.7
  })), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    x: 569,
    y: 179,
    fill: "#cbd5e1",
    fontSize: 8
  }, "or grounded RAG answer")), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 698,
    y1: 195,
    x2: 712,
    y2: 195,
    stroke: "#a78bfa",
    strokeWidth: 1.5,
    markerEnd: "url(#amv)"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 712,
    y: 100,
    width: 210,
    height: 190,
    rx: 6,
    fill: "#0a1628",
    stroke: "#a78bfa",
    strokeWidth: 1.5
  })), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    x: 817,
    y: 118,
    textAnchor: "middle",
    fill: "#a78bfa",
    fontSize: 10,
    fontWeight: 700
  }, "Reply to Visitor")), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 724,
    y1: 126,
    x2: 908,
    y2: 126,
    stroke: "rgba(167,139,250,0.12)",
    strokeWidth: 1
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 724,
    cy: 141,
    r: 2.5,
    fill: "#a78bfa",
    opacity: 0.7
  })), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    x: 733,
    y: 145,
    fill: "#cbd5e1",
    fontSize: 8
  }, "/invoke/stream \u2014 per-node progress")), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 724,
    cy: 158,
    r: 2.5,
    fill: "#a78bfa",
    opacity: 0.7
  })), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    x: 733,
    y: 162,
    fill: "#cbd5e1",
    fontSize: 8
  }, "client-side typewriter reveal")), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 724,
    cy: 175,
    r: 2.5,
    fill: "#a78bfa",
    opacity: 0.7
  })), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    x: 733,
    y: 179,
    fill: "#cbd5e1",
    fontSize: 8
  }, "schedule_step stops here")), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 724,
    cy: 192,
    r: 2.5,
    fill: "#a78bfa",
    opacity: 0.7
  })), _text26 || (_text26 = /*#__PURE__*/React.createElement("text", {
    x: 733,
    y: 196,
    fill: "#cbd5e1",
    fontSize: 8
  }, "\u2192 confirmation gate next (below)")), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 300,
    width: 932,
    height: 150,
    rx: 8,
    fill: "rgba(245,158,11,0.02)",
    stroke: "#f59e0b",
    strokeWidth: 1,
    strokeDasharray: "6,4"
  })), _text27 || (_text27 = /*#__PURE__*/React.createElement("text", {
    x: 28,
    y: 315,
    fill: "#92600a",
    fontSize: 8.5,
    fontStyle: "italic",
    fontWeight: 600
  }, "HUMAN CONFIRMATION GATE \u2014 nothing books itself")), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 328,
    width: 210,
    height: 100,
    rx: 6,
    fill: "#0a1628",
    stroke: "#f59e0b",
    strokeWidth: 1.5
  })), _text28 || (_text28 = /*#__PURE__*/React.createElement("text", {
    x: 131,
    y: 346,
    textAnchor: "middle",
    fill: "#f59e0b",
    fontSize: 10,
    fontWeight: 700
  }, "Pending Proposal")), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 38,
    y1: 354,
    x2: 214,
    y2: 354,
    stroke: "rgba(245,158,11,0.12)",
    strokeWidth: 1
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 369,
    r: 2.5,
    fill: "#f59e0b",
    opacity: 0.7
  })), _text29 || (_text29 = /*#__PURE__*/React.createElement("text", {
    x: 47,
    y: 373,
    fill: "#cbd5e1",
    fontSize: 8
  }, "pending_action \u2014 in memory only")), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 386,
    r: 2.5,
    fill: "#f59e0b",
    opacity: 0.7
  })), _text30 || (_text30 = /*#__PURE__*/React.createElement("text", {
    x: 47,
    y: 390,
    fill: "#cbd5e1",
    fontSize: 8
  }, "no calendar event created yet")), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 236,
    y1: 378,
    x2: 250,
    y2: 378,
    stroke: "#f59e0b",
    strokeWidth: 1.5,
    markerEnd: "url(#amo)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 328,
    width: 210,
    height: 100,
    rx: 6,
    fill: "#0a1628",
    stroke: "#f59e0b",
    strokeWidth: 1.5
  })), _text31 || (_text31 = /*#__PURE__*/React.createElement("text", {
    x: 355,
    y: 346,
    textAnchor: "middle",
    fill: "#f59e0b",
    fontSize: 10,
    fontWeight: 700
  }, "Visitor Confirms")), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 262,
    y1: 354,
    x2: 438,
    y2: 354,
    stroke: "rgba(245,158,11,0.12)",
    strokeWidth: 1
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 262,
    cy: 369,
    r: 2.5,
    fill: "#f59e0b",
    opacity: 0.7
  })), _text32 || (_text32 = /*#__PURE__*/React.createElement("text", {
    x: 271,
    y: 373,
    fill: "#cbd5e1",
    fontSize: 8
  }, "POST /confirm")), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 262,
    cy: 386,
    r: 2.5,
    fill: "#f59e0b",
    opacity: 0.7
  })), _text33 || (_text33 = /*#__PURE__*/React.createElement("text", {
    x: 271,
    y: 390,
    fill: "#cbd5e1",
    fontSize: 8
  }, "emails single-use link (10-min TTL)")), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 460,
    y1: 378,
    x2: 474,
    y2: 378,
    stroke: "#f59e0b",
    strokeWidth: 1.5,
    markerEnd: "url(#amo)"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 474,
    y: 328,
    width: 210,
    height: 100,
    rx: 6,
    fill: "#0a1628",
    stroke: "#f59e0b",
    strokeWidth: 1.5
  })), _text34 || (_text34 = /*#__PURE__*/React.createElement("text", {
    x: 579,
    y: 346,
    textAnchor: "middle",
    fill: "#f59e0b",
    fontSize: 10,
    fontWeight: 700
  }, "Clicks Email Link")), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 486,
    y1: 354,
    x2: 662,
    y2: 354,
    stroke: "rgba(245,158,11,0.12)",
    strokeWidth: 1
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 486,
    cy: 369,
    r: 2.5,
    fill: "#f59e0b",
    opacity: 0.7
  })), _text35 || (_text35 = /*#__PURE__*/React.createElement("text", {
    x: 495,
    y: 373,
    fill: "#cbd5e1",
    fontSize: 8
  }, "GET /confirm-email?token=...")), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 486,
    cy: 386,
    r: 2.5,
    fill: "#f59e0b",
    opacity: 0.7
  })), _text36 || (_text36 = /*#__PURE__*/React.createElement("text", {
    x: 495,
    y: 390,
    fill: "#cbd5e1",
    fontSize: 8
  }, "verifies visitor owns the address")), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 684,
    y1: 378,
    x2: 698,
    y2: 378,
    stroke: "#f59e0b",
    strokeWidth: 1.5,
    markerEnd: "url(#amo)"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 698,
    y: 328,
    width: 210,
    height: 100,
    rx: 6,
    fill: "#0a1628",
    stroke: "#22c55e",
    strokeWidth: 1.5
  })), _text37 || (_text37 = /*#__PURE__*/React.createElement("text", {
    x: 803,
    y: 346,
    textAnchor: "middle",
    fill: "#22c55e",
    fontSize: 10,
    fontWeight: 700
  }, "Real Booking Fires")), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 710,
    y1: 354,
    x2: 886,
    y2: 354,
    stroke: "rgba(34,197,94,0.12)",
    strokeWidth: 1
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 710,
    cy: 369,
    r: 2.5,
    fill: "#22c55e",
    opacity: 0.7
  })), _text38 || (_text38 = /*#__PURE__*/React.createElement("text", {
    x: 719,
    y: 373,
    fill: "#cbd5e1",
    fontSize: 8
  }, "Calendar invite + attendee added")), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 710,
    cy: 386,
    r: 2.5,
    fill: "#22c55e",
    opacity: 0.7
  })), _text39 || (_text39 = /*#__PURE__*/React.createElement("text", {
    x: 719,
    y: 390,
    fill: "#cbd5e1",
    fontSize: 8
  }, "2 emails: owner summary, visitor note")), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 460,
    width: 932,
    height: 130,
    rx: 8,
    fill: "rgba(255,255,255,0.015)",
    stroke: "#475569",
    strokeWidth: 1,
    strokeDasharray: "6,4"
  })), _text40 || (_text40 = /*#__PURE__*/React.createElement("text", {
    x: 28,
    y: 475,
    fill: "#64748b",
    fontSize: 8.5,
    fontStyle: "italic",
    fontWeight: 600
  }, "GUARDRAILS &amp; INFRASTRUCTURE")), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 486,
    width: 225,
    height: 80,
    rx: 6,
    fill: "#0a1628",
    stroke: "#ef4444",
    strokeWidth: 1.5
  })), _text41 || (_text41 = /*#__PURE__*/React.createElement("text", {
    x: 134,
    y: 504,
    textAnchor: "middle",
    fill: "#ef4444",
    fontSize: 10,
    fontWeight: 700
  }, "Content Moderation")), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 34,
    y1: 510,
    x2: 234,
    y2: 510,
    stroke: "rgba(239,68,68,0.1)",
    strokeWidth: 1
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 522,
    r: 2,
    fill: "#ef4444",
    opacity: 0.7
  })), _text42 || (_text42 = /*#__PURE__*/React.createElement("text", {
    x: 42,
    y: 526,
    fill: "#64748b",
    fontSize: 8
  }, "OpenAI moderation endpoint")), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 538,
    r: 2,
    fill: "#ef4444",
    opacity: 0.7
  })), _text43 || (_text43 = /*#__PURE__*/React.createElement("text", {
    x: 42,
    y: 542,
    fill: "#64748b",
    fontSize: 8
  }, "fails open on API errors")), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 259,
    y: 486,
    width: 225,
    height: 80,
    rx: 6,
    fill: "#0a1628",
    stroke: "#ef4444",
    strokeWidth: 1.5
  })), _text44 || (_text44 = /*#__PURE__*/React.createElement("text", {
    x: 371,
    y: 504,
    textAnchor: "middle",
    fill: "#ef4444",
    fontSize: 10,
    fontWeight: 700
  }, "Rate Limits &amp; Daily Caps")), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 271,
    y1: 510,
    x2: 471,
    y2: 510,
    stroke: "rgba(239,68,68,0.1)",
    strokeWidth: 1
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 271,
    cy: 522,
    r: 2,
    fill: "#ef4444",
    opacity: 0.7
  })), _text45 || (_text45 = /*#__PURE__*/React.createElement("text", {
    x: 279,
    y: 526,
    fill: "#64748b",
    fontSize: 8
  }, "burst: 20 req / 60s per IP")), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 271,
    cy: 538,
    r: 2,
    fill: "#ef4444",
    opacity: 0.7
  })), _text46 || (_text46 = /*#__PURE__*/React.createElement("text", {
    x: 279,
    y: 542,
    fill: "#64748b",
    fontSize: 8
  }, "5 daily caps \u2014 messages &amp; bookings")), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 496,
    y: 486,
    width: 200,
    height: 80,
    rx: 6,
    fill: "#0a1628",
    stroke: "#06B6D4",
    strokeWidth: 1.5
  })), _text47 || (_text47 = /*#__PURE__*/React.createElement("text", {
    x: 596,
    y: 504,
    textAnchor: "middle",
    fill: "#06B6D4",
    fontSize: 10,
    fontWeight: 700
  }, "FastAPI + LangGraph")), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    x1: 508,
    y1: 510,
    x2: 684,
    y2: 510,
    stroke: "rgba(6,182,212,0.1)",
    strokeWidth: 1
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 508,
    cy: 522,
    r: 2,
    fill: "#06B6D4",
    opacity: 0.7
  })), _text48 || (_text48 = /*#__PURE__*/React.createElement("text", {
    x: 516,
    y: 526,
    fill: "#64748b",
    fontSize: 8
  }, "MemorySaver checkpointer")), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 508,
    cy: 538,
    r: 2,
    fill: "#06B6D4",
    opacity: 0.7
  })), _text49 || (_text49 = /*#__PURE__*/React.createElement("text", {
    x: 516,
    y: 542,
    fill: "#64748b",
    fontSize: 8
  }, "containerized on Cloud Run")), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 708,
    y: 486,
    width: 222,
    height: 80,
    rx: 6,
    fill: "#0a1628",
    stroke: "#a78bfa",
    strokeWidth: 1.5
  })), _text50 || (_text50 = /*#__PURE__*/React.createElement("text", {
    x: 819,
    y: 504,
    textAnchor: "middle",
    fill: "#a78bfa",
    fontSize: 9.5,
    fontWeight: 700
  }, "Google OAuth + Secret Mgr")), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    x1: 720,
    y1: 510,
    x2: 918,
    y2: 510,
    stroke: "rgba(167,139,250,0.1)",
    strokeWidth: 1
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 720,
    cy: 522,
    r: 2,
    fill: "#a78bfa",
    opacity: 0.7
  })), _text51 || (_text51 = /*#__PURE__*/React.createElement("text", {
    x: 728,
    y: 526,
    fill: "#64748b",
    fontSize: 8
  }, "Gmail + Calendar APIs")), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 720,
    cy: 538,
    r: 2,
    fill: "#a78bfa",
    opacity: 0.7
  })), _text52 || (_text52 = /*#__PURE__*/React.createElement("text", {
    x: 728,
    y: 542,
    fill: "#64748b",
    fontSize: 8
  }, "keys injected at runtime")), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 612,
    x2: 42,
    y2: 612,
    stroke: "#f472b6",
    strokeWidth: 1.5
  })), _text53 || (_text53 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 616,
    fill: "#475569",
    fontSize: 8.5
  }, "visitor / session")), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    x1: 164,
    y1: 612,
    x2: 184,
    y2: 612,
    stroke: "#06B6D4",
    strokeWidth: 1.5
  })), _text54 || (_text54 = /*#__PURE__*/React.createElement("text", {
    x: 190,
    y: 616,
    fill: "#475569",
    fontSize: 8.5
  }, "planning / routing")), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    x1: 322,
    y1: 612,
    x2: 342,
    y2: 612,
    stroke: "#22c55e",
    strokeWidth: 1.5
  })), _text55 || (_text55 = /*#__PURE__*/React.createElement("text", {
    x: 348,
    y: 616,
    fill: "#475569",
    fontSize: 8.5
  }, "knowledge / success")), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    x1: 490,
    y1: 612,
    x2: 510,
    y2: 612,
    stroke: "#f59e0b",
    strokeWidth: 1.5
  })), _text56 || (_text56 = /*#__PURE__*/React.createElement("text", {
    x: 516,
    y: 616,
    fill: "#475569",
    fontSize: 8.5
  }, "scheduling flow")), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    x1: 638,
    y1: 612,
    x2: 658,
    y2: 612,
    stroke: "#ef4444",
    strokeWidth: 1.5
  })), _text57 || (_text57 = /*#__PURE__*/React.createElement("text", {
    x: 664,
    y: 616,
    fill: "#475569",
    fontSize: 8.5
  }, "guardrails")), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    x1: 758,
    y1: 612,
    x2: 778,
    y2: 612,
    stroke: "#a78bfa",
    strokeWidth: 1.5
  })), _text58 || (_text58 = /*#__PURE__*/React.createElement("text", {
    x: 784,
    y: 616,
    fill: "#475569",
    fontSize: 8.5
  }, "output / infra")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgentPipeline);
export default __webpack_public_path__ + "static/media/agent-pipeline.90ecaf6d01b14c4d00f65042b596d139.svg";
export { ForwardRef as ReactComponent };